import { useAuth } from '../../context/AuthContext';
import DashboardAdmin from './DashboardAdmin';
import DashboardEmpresa from './DashboardEmpresa';

/**
 * Elige el dashboard correcto segun rol.
 *  - admin_general / operador: ven el dashboard administrativo
 *  - admin_empresa: ve el dashboard de su empresa
 *  - admin_general impersonando: ve el dashboard de la empresa target
 */
export default function Dashboard() {
  const { profile, impersonatingEmpresaId } = useAuth();

  if (!profile) return null;

  if (impersonatingEmpresaId || profile.rol === 'admin_empresa') {
    return <DashboardEmpresa />;
  }

  return <DashboardAdmin />;
}
